






























































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudEvaluacionHogarModel, {
  SolicitudEvaluacionHogarMiembro,
  SolicitudEvaluacionHogarMiembroDocumento
} from "@/models/tramite/solicitud-evaluacion-hogar";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import Telefono from "@/models/telefono.model";
import moment from "moment";
import MiembroAdd from "../miembro/add.vue";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Helpers from "@/helpers/helper";
import NameValue from "@/models/nameValue.model";
import { Utils } from "@/core/Utils";
import { RowTable } from "@/typings/BRowTable";
import TipoTramite from "@/models/tipoTramite";
import { TipoTramiteCode } from "@/enums/TipoTramiteCode";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import externalService from '@/services/external.service';
import LatestRequest from "@/core/HttpResources/LatestRequest";
@Component
export default class SolicitudEvaluacionHogar extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly codigoMiembrosDocAdicionales!: string;
  direccionesTableConfig!: BTableConfig<PersonaDireccion>;
  direccionPropuestaInit = new Direccion();
  direccionPropuesta = this.map<Direccion>(this.direccionPropuestaInit);
  nameValue = new NameValue();
  TipoTramiteCode = TipoTramiteCode;
  model = new SolicitudEvaluacionHogarModel();
  parentesco = new NameValue();
  miembrosTableConfig: BTableConfig<SolicitudEvaluacionHogarMiembro>;
  miembroAddCedula: Miembro | undefined | null = null;
  miembroAddSinCedula: Miembro | undefined | null = null;
  adding = false;
  activeTabMiembroAdd = 0;
  editing = false;
  editingMiembro: SolicitudEvaluacionHogarMiembro | undefined | null = null;
  editingMiembroModel:
    | SolicitudEvaluacionHogarMiembro
    | undefined
    | null = null;
  editingMiembroToSave: SolicitudEvaluacionHogarMiembro | null = null;
  centroAcamicoSelected = new NameValue();
  private siubenRequest = new LatestRequest();
  constructor() {
    super();
    this.miembrosTableConfig = new BTableConfig<
      SolicitudEvaluacionHogarMiembro
    >();
    this.miembrosTableConfig.loadOnMount = false;
    this.miembrosTableConfig.showReload = false;
    this.miembrosTableConfig.enableDefaultColumns = false;
    this.miembrosTableConfig.actions.remove = this.onRemoveMiembro;
    this.miembrosTableConfig.actions.edit = this.onEditMiembro;
    // this.miembrosTableConfig.detailed = true;
    // this.miembrosTableConfig.detailing.key = 'personaId'
    let active = new BTableColumn("key", " ", false);
    active.customTemplate = true;
    active.width = "60";
    let nombre = new BTableColumn("persona.nombre1", "Nombre");
    nombre.customTemplate = true;
    nombre.templateSlot = "nombre1";
    let cedula = new BTableColumn("persona.cedula", "Cédula");
    cedula.type = BTableColumnType.Custom;
    cedula.customFilter = Helpers.Filters.Cedula;
    let edad = new BTableColumn("persona.fechaNacimiento", "Edad");
    edad.customTemplate = true;
    edad.templateSlot = "column-edad";
    let parentesco = new BTableColumn("parentescoNombre", "Parentesco", false);
    let sexo = new BTableColumn("persona.sexo", "Genero");
    sexo.type = BTableColumnType.Custom;
    sexo.customFilter = Helpers.Filters.Sexo;
    this.miembrosTableConfig.insertColumns(
      active,
      nombre,
      cedula,
      edad,
      parentesco,
      sexo
    );
  }
  repoPersona = new BaseRepository<Persona>("Personas");
  get miembroRows() {
    return this.miembrosTableConfig.data;
  }
  showModalMiembroRow(row: any) {
    this.miembroRows.forEach((x: any) => {
      if (x.key === row.key) {
        x.active = true;
        this.$forceUpdate();
      }
    });
  }
  hideModalMiembroRow(row: any) {
    this.miembroRows.forEach((x: any) => {
      if (x.key === row.key) {
        x.active = false;
        this.$forceUpdate();
      }
    });
  }
  getNombreCompleto(persona: Persona) {
    let n1 = persona.nombre1;
    let n2 = persona.nombre2;
    let a1 = persona.apellido1;
    let a2 = persona.apellido2;
    let full = n1;
    if (n2) full = full + " " + n2;
    if (a1) full = full + " " + a1;
    if (a2) full = full + " " + a2;
    return full;
  }
  get esReevaluacion() {
    this.model.esReevaluacion = this.tipoTramite
      ? this.tipoTramite.codigo === "TramiteReevaluaccionHogar"
      : false;
    return this.model.esReevaluacion;
  }
  get tipoTramiteCode() {
    return this.tipoTramite ? this.tipoTramite.codigo : "";
  }
  get personaId() {
    return this.persona.id;
  }
  get persona() {
    let value = this.solicitante || new Persona();
    this.model.personaId = value.id;
    this.model.estadoCivil = value.estadoCivil;
    this.model.centroAcademicoId = value.centroAcademicoId;
    this.model.cursoEstudiante = value.cursoEstudiante;
    //this.model.discapacitado = value.discapacitado;
    //this.model.incapacitado = value.incapacitado;
    //this.model.lee = value.lee;
    //this.model.escribe = value.escribe;
    //this.model.embarazada = value.embarazada;
    this.model.tiempoEmbarazo = value.tiempoEmbarazo;
    this.model.medidaTiempoEmbarazo = value.medidaTiempoEmbarazo;
    return value;
  }
  // async mounted() {
  //   this.parentesco = await new BaseHttpClient("NameValues").getAsync<NameValue>(`Parentesco/child/${Helpers.Codes.Parentesco.JefeHogar}`);
  //   this.jefe.parentescoId = this.parentesco.id;
  //   this.jefe.parentescoNombre = this.parentesco.descripcion;
  // }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp(
        "codigoMiembrosDocAdicionales",
        "string",
        true,
        "Cód. docs. adicionales para miembros"
      )
    );
    this.$emit("render", props);
    if (this.esReevaluacion) {
      this.getFormasCoccionAlimentos();
    }
  }
  beforeDestroy() {
    this.siubenRequest.cancel();
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.solicitudEvaluacionHogar)
        delete contenido.solicitudEvaluacionHogar;
      this.$emit("update:content", contenido);
    }
  }
  formaCoccionAlimentos: NameValue[] = [];
  async getFormasCoccionAlimentos() {
    this.formaCoccionAlimentos = await new BaseHttpClient(
      "NameValues"
    ).getAsync("FORMA_COCCION_ALIMENTOS/children");
  }
  onCheckFormaCoccion(value: boolean, item: NameValue) {
    this.model.formaCoccionAlimentosOtroIsChecked =
      item.descripcion === "Otro" && value;
    if (value) {
      let otro = {
        descripcion: item.descripcion,
        nameValueId: item.id
      };
      this.model.formaCoccionAlimentos.push(otro);
    } else {
      let index = this.model.formaCoccionAlimentos.findIndex(
        x => x.nameValueId === item.id
      );
      this.model.formaCoccionAlimentos.splice(index, 1);
    }
  }
  onTelefonosChange(telefonos: Telefono[]) {
    this.model.telefonos = [];
    telefonos.forEach(tel => this.model.telefonos.push(tel));
  }
  onCorreosChange(correos: string[]) {
    this.model.listaCorreos = [];
    correos.forEach(mail => this.model.listaCorreos.push(mail));
    this.model.correos = correos.join(";");
  }
  onSelect(selected: PersonaDireccion, oldSelected: PersonaDireccion) {
    this.direccionPropuesta = selected.direccion as Direccion;
    this.model.direccionId = this.direccionPropuesta.id;
  }
  onAdd(added: PersonaDireccion) {
    this.direccionPropuesta = added.direccion as Direccion;
    this.model.direccionId = this.direccionPropuesta.id;
  }
  onLoadTable(config: BTableConfig<PersonaDireccion>) {
    this.direccionesTableConfig = config;
  }
  quitDireccion() {
    this.direccionPropuesta = this.map<Direccion>(this.direccionPropuestaInit);
    this.direccionesTableConfig.selection.selected = null;
    this.model.direccionId = undefined;
  }
  public onRemoveMiembro(
    id: number,
    row: SolicitudEvaluacionHogarMiembro,
    props: RowTable<SolicitudEvaluacionHogarMiembro>
  ) {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este miembro?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => {
        let index = this.miembrosTableConfig.data.findIndex(
          x => x.key === row.key
        );
        this.miembrosTableConfig.data.splice(index, 1);
        let indexx = this.model.miembros.findIndex(x => x.key === row.key);
        this.model.miembros.splice(indexx, 1);
        //this.setMiembros();
      }
    });
  }
  quitCedulaMask(cedula?: string) {
    if (cedula) return cedula.replace(/-/g, "");
    return "";
  }
  addingMiembro = false;
  public async onAddMiembro() {
    let addingMiembro = this
      .miembroAddSinCedula as SolicitudEvaluacionHogarMiembro;
    let data = this.miembrosTableConfig.data;
    let ref = this.$refs.miembro_add_sin_cedula as MiembroAdd;
    let isValid = await ref.isValid();
    if (!isValid) return;
    if (data.some(x => this.equalPerson(x.persona, addingMiembro.persona))) {
      this.operationNoAllowed(
        "La persona ya es parte de la composición familiar"
      );
      return;
    }
    if (this.solicitante.id === addingMiembro.personaId) {
      this.operationNoAllowed(
        "El solicitante es el JEFE DEL HOGAR, ya es parte de la composición"
      );
      return;
    }
    if(addingMiembro.persona && addingMiembro.persona.cedula){
      const request = this.siubenRequest.begin();
      let estado: any = { beneficiario: false, evaluado: false };
      try {
        estado = await externalService.verificarEstadoEnInstituciones(
          addingMiembro.persona.cedula,
          request.options
        );
        if (!this.siubenRequest.isLatest(request.version)) return;
      } catch (error) {
        if (LatestRequest.isCancelled(error)) return;
        if (!this.siubenRequest.isLatest(request.version)) return;
        if (LatestRequest.isExternalUnavailable(error)) {
          this.operationNoAllowed("No fue posible validar la información en SIUBEN en este momento. Puede continuar con el trámite.");
        } else {
          throw error;
        }
      }
      if(estado.beneficiario){
        this.operationNoAllowed(
        "El miembro que intenta agregar ya es parte de otra composición familiar"
      );
        return;
      }
       if(estado.evaluado){
this.operationNoAllowed(
        "El miembro que intenta agregar ya ha sido levantado por SIUBEN"
      );
        return;
      }
    }
    if (!addingMiembro.personaId && addingMiembro.persona) {
      this.addingMiembro = true;
      let body = addingMiembro.persona;
      body.cedula = this.quitCedulaMask(body.cedula);
      body.cedulaPadre = this.quitCedulaMask(body.cedulaPadre);
      body.cedulaMadre = this.quitCedulaMask(body.cedulaMadre);
      if (body.telefono)
        body.telefono = Helpers.Filters.PhoneToStr(body.telefono);
      if (body.estaEstudiando) body.ultimoNivelAcademico = undefined;
      else if (body.estaEstudiando === false) {
        body.centroAcademicoId = undefined;
        body.centroAcademicoOtro = undefined;
        body.cursoEstudiante = undefined;
      }
      let p = await this.repoPersona.create(body);
      addingMiembro.personaId = p.id;
      addingMiembro.persona = p;
      this.addingMiembro = false;
    }
    let miembro = this.map<SolicitudEvaluacionHogarMiembro>(
      addingMiembro
    ) as any;
    miembro.key = Utils.newGUID();
    this.miembrosTableConfig.data.push(miembro);
    this.model.miembros.push(miembro);
    this.adding = false;
    //this.setMiembros();
  }
  public onEditMiembro(
    id: number,
    row: SolicitudEvaluacionHogarMiembro,
    props: RowTable<SolicitudEvaluacionHogarMiembro>
  ) {
    this.editingMiembroModel = this.mapModel(row);
    this.editingMiembro = this.mapModel(row);
    this.editing = true;
  }
  equalPerson(a: Persona | undefined, b: Persona | undefined): boolean {
    let p = a as Persona;
    let t = b as Persona;
    if (p.cedula || t.cedula) return p.cedula === t.cedula;
    return (
      p.nombre1 === t.nombre1 &&
      p.apellido1 === t.apellido1 &&
      p.nombre2 === t.nombre2 &&
      p.apellido2 === t.apellido2
    );
  }
  onSaveEdit() {
    let index = this.miembrosTableConfig.data.findIndex(
      x =>
        x.key === (this.editingMiembro as SolicitudEvaluacionHogarMiembro).key
    );
    this.miembrosTableConfig.data.splice(
      index,
      1,
      this.mapModel(this.editingMiembroToSave)
    );
    let indexx = this.model.miembros.findIndex(
      x => x.key === (this.editingMiembroToSave as any).key
    );
    this.model.miembros.splice(
      indexx,
      1,
      this.mapModel(this.editingMiembroToSave)
    );
    this.editing = false;
    //this.setMiembros();
  }
  mapModel(obj: any) {
    let m = this.map<SolicitudEvaluacionHogarMiembro>(obj);
    let p = m.persona as Persona;
    (m.persona as Persona).nombreCompleto = `${p.nombre1} ${p.nombre2} ${p.apellido1} ${p.apellido2}`;
    return m;
  }
  editModelChange(value: SolicitudEvaluacionHogarMiembro) {
    this.editingMiembroToSave = value;
  }
  restartEdit() {
    this.editingMiembro = this.mapModel(this.editingMiembroModel);
  }
  closeEdit() {
    this.editing = false;
    this.editingMiembro = null;
    this.editingMiembroModel = null;
    this.editingMiembroToSave = null;
  }
  showModalAddMiembro() {
    this.closeAdd();
    this.adding = true;
  }
  closeAdd() {
    this.adding = false;
    this.miembroAddCedula = null;
    this.miembroAddSinCedula = null;
  }
  getValueDate(value: string) {
    return moment(value).format("L");
  }
  get telefonoFamiliarFueraHogar() {
    if (this.model.telefonoFamiliarFueraHogar)
      return Helpers.Filters.PhoneToStr(this.model.telefonoFamiliarFueraHogar);
    return "";
  }
  get parentescoRequiredError() {
    return !!(
      ((this.model.nombreFamiliarFueraHogar || "").trim() ||
        (this.model.telefonoFamiliarFueraHogar || "").trim()) &&
      !this.model.parentescoFamiliarFueraHogarId
    );
  }
  onSelectParentescoFueraHogar(value: NameValue) {
    this.model.parentescoFamiliarFueraHogarNombre = value
      ? value.descripcion
      : undefined;
  }
  onRemoveParentescoFueraHogar() {
    this.model.parentescoFamiliarFueraHogarId = undefined;
    this.model.parentescoFamiliarFueraHogarNombre = undefined;
  }
  get memberDocumentRefs() {
    let refs = this.$refs.miembroDocumentos as any;
    if (!refs) return [];
    return Array.isArray(refs) ? refs : [refs];
  }
  getMissingRequiredDocuments(tipoDocumentos: any[]) {
    return (tipoDocumentos || []).filter(
      x => x.requerido && !x.fileSelected
    );
  }
  validateContactRequirements() {
    if (!this.model.direccionId) {
      this.operationFailed("Debe seleccionar una dirección para continuar.");
      return false;
    }
    if (!this.model.telefonos || !this.model.telefonos.length) {
      this.operationFailed(
        "Debe agregar al menos un número de teléfono para continuar."
      );
      return false;
    }
    return true;
  }
  validateMemberRequiredDocuments() {
    for (const docsRef of this.memberDocumentRefs) {
      let missingDocs = this.getMissingRequiredDocuments(docsRef.tipoDocumentos);
      if (!missingDocs.length) continue;

      let miembro = this.miembroRows.find(
        x => String(x.personaId) === String(docsRef.refValue)
      );
      let miembroNombre =
        miembro && miembro.persona
          ? this.getNombreCompleto(miembro.persona)
          : "el miembro seleccionado";
      let names = missingDocs.map(x => x.tipoDocumentoNombre).join(", ");
      this.operationFailed(
        `Debe adjuntar los documentos requeridos para ${miembroNombre}: ${names}`
      );
      return false;
    }
    return true;
  }
  validateStepFields() {
    if (!this.esReevaluacion && !String(this.model.descripcion || "").trim()) {
      this.operationFailed("Debe completar la descripción de la solicitud para continuar.");
      return false;
    }

    if (this.model.embarazada && !this.model.tiempoEmbarazo) {
      this.operationFailed("Debe indicar el tiempo de embarazo para continuar.");
      return false;
    }

    if (
      this.model.telefonoFamiliarFueraHogar &&
      !/^\(\d{3}\) \d{3}-\d{4}$/.test(this.model.telefonoFamiliarFueraHogar)
    ) {
      this.operationFailed(
        "El teléfono de la persona que no vive con usted debe tener el formato completo."
      );
      return false;
    }

    if (this.parentescoRequiredError) {
      this.operationFailed("Debe seleccionar el parentesco de la persona para continuar.");
      return false;
    }

    return true;
  }
  public async validateStep() {
    if (!this.validateStepFields()) return false;
    if (!this.validateContactRequirements()) return false;
    return true;
  }
  public async isValid() {
    let isValid = await this.validateStep();
    if (!isValid) return false;
    isValid = await this.validateCurrentValidator();
    if (!isValid) return false;
    if (!this.validateMemberRequiredDocuments()) return false;
    return true;
  }
  @Watch("model", { deep: true })
  set(model: SolicitudEvaluacionHogarModel) {
    if (this.content) {
      let contenido = this.content as any;
      contenido.descripcion = model.descripcion;
      contenido.solicitudEvaluacionHogar = this.map<
        SolicitudEvaluacionHogarModel
      >(model);
      contenido.solicitudEvaluacionHogar.telefonoFamiliarFueraHogar = this.telefonoFamiliarFueraHogar;
      if (contenido.solicitudEvaluacionHogar.estaEstudiando)
        contenido.solicitudEvaluacionHogar.ultimoNivelAcademico = undefined;
      else if (contenido.solicitudEvaluacionHogar.estaEstudiando === false) {
        contenido.solicitudEvaluacionHogar.centroAcademicoId = undefined;
        contenido.solicitudEvaluacionHogar.centroAcademicoOtro = undefined;
        contenido.solicitudEvaluacionHogar.cursoEstudiante = undefined;
      }
      this.$emit("update:content", contenido);
    }
  }
  onChangeDocs(
    miembro: SolicitudEvaluacionHogarMiembro,
    tipos: any,
    docs: any[]
  ) {
    // let contenido = this.content as any;
    // let main = contenido.solicitudEvaluacionHogar as SolicitudEvaluacionHogarModel;
    // let member = main.miembros.find(
    //   x => x.personaId == miembro.personaId
    // ) as SolicitudEvaluacionHogarMiembro;
    // this.$emit("update:content", contenido);
    miembro.documentos = docs.map(x => {
      let doc = new SolicitudEvaluacionHogarMiembroDocumento();
      doc.personaId = miembro.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });
    this.model.miembros.forEach(x => {
      if (x.personaId === miembro.personaId) {
        x.documentos = miembro.documentos;
      }
    });
    this.set(this.model);
    // if (this.content) {
    //   let contenido = this.content as any;
    //   contenido.solicitudEvaluacionHogar = this.map<SolicitudEvaluacionHogarModel>(this.model);
    //   this.$emit("update:content", contenido);
    // }
  }
  @Watch("codigoMiembrosDocAdicionales", { immediate: true })
  async onCodigoDocAdicionalesChange(value: string) {
    if (value) {
      this.nameValue = await new BaseRepository<NameValue>("namevalues").one(
        `codigo="${value}"`
      );
    }
  }
}
